<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      show: false,
    }
  },
  watch: {
    snackbar(newValue) {
      this.show = newValue.show
    },
    show(newValue) {
      if (!newValue) {
        this.$store.dispatch('feedback/closeSnack')
      }
    },
  },
  computed: {
    // snackbar() {
    //   return store.getters['feedback/snack']
    // },
    ...mapState('feedback', ['snackbar']),
  },
}
</script>

<template>
  <div class="v-application">
    <v-snackbar
      v-model="show"
      :timeout="snackbar.timeout"
      right
      :color="snackbar.color"
      :class="
        ['success', 'error', 'warning'].includes(snackbar.color) ? 'black--text' : ''
      "
    >
      <span v-html="(snackbar.text || '').replace(/\n/g, '<br>')"></span>
      <v-btn
        v-if="snackbar.button"
        :color="snackbar.button.color || 'white'"
        :class="
          ['success', 'error', 'warning'].includes(snackbar.color) ? 'black--text' : ''
        "
        text
        @click="
          () => {
            show = false
            if (snackbar.button.callback) {
              snackbar.button.callback()
            }
          }
        "
      >
        {{ snackbar.button.text || 'Fechar' }}
      </v-btn>
    </v-snackbar>
  </div>
</template>
